import { render } from "./BaseButton.vue?vue&type=template&id=677e87b0&scoped=true"
const script = {}

import "./BaseButton.vue?vue&type=style&index=0&id=677e87b0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677e87b0"]])

export default __exports__